import styled from 'styled-components';
import { boxFlex } from './../../../styled/index';
import { detectMobile } from '../../../utils/UiHelper';

const getContentHeight = (isModal) => {
    if (isModal) {
        return 'auto';
    } else if (detectMobile()) {
        return '146px';
    } else {
        return '146px';
    }
};
export const CombosItemWrapper = styled(boxFlex)`
    width: 100%;
    padding: 16px;
    border: 1px solid #dfe5ed;
    border-radius: 8px;
    background: #fff;
    margin-right: 8px;
    @media screen and (max-width: 1024px) {
        min-width: ${detectMobile ? '290px' : '100%'};
        max-width: ${detectMobile() ? '290px' : '100%'};
        margin-right: 0;
    }
`;

export const CombosItemTop = styled(boxFlex)`
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    &:hover {
        cursor: pointer;
    }
`;
export const CombosItemTopLeft = styled(boxFlex)`
    width: calc(100% - 53px);
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
`;

export const CombosItemFavorite = styled(boxFlex)`
    width: auto;
    font-size: 10px;
    line-height: 16px;
    padding: 4px 8px;
    color: #0749b2;
    border-radius: 4px;
    background: #eaf1fe;
    margin-left: 8px;
`;

export const CombosItemSeeCoupon = styled(boxFlex)`
    width: 53px;
    font-size: 10px;
    color: #4f555e;
    flex-direction: row;
    align-items: center;
`;

export const CombosItemContent = styled.div`
    height: auto;
    width: 100%;
    box-sizing: border-box;
    &:hover {
        cursor: pointer;
    }
`;
export const CombosItemContainer = styled(boxFlex)`
    height: ${({ isModal }) => getContentHeight(isModal)};
    width: auto;
    margin: 16px 0;
    padding-left: 22px;
    position: relative;
    overflow: hidden;
    &:hover {
        cursor: ${({ isModal }) => (isModal ? 'default' : 'pointer')};
    }
    &:before {
        content: '';
        height: ${(props) =>
            props.isModal ? 'calc(100% - 36px)' : 'calc(100% - 46px)'};
        width: 1px;
        background: #4f555e;
        position: absolute;
        left: 4px;
        top: 17px;
        transform: translateX(-50%);
        z-index: 1;
    }
    &.long {
        &:before {
            height: calc(100% - 16px);
        }
        &:after {
            content: '';
            height: 50px;
            width: 100%;
            left: 0;
            bottom: 0;
            background: linear-gradient(
                to bottom,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 1) 84%,
                rgba(255, 255, 255, 1) 100%
            );
            position: absolute;
            z-index: 3;
        }
    }
`;

export const CombosItemEvent = styled(boxFlex)`
    width: 100%;
    flex-direction: row;
    margin: 8px 0 0;
    justify-content: space-between;
    position: relative;
    &:before {
        content: '';
        height: 4px;
        width: 4px;
        border: 1px solid #4f555e;
        border-radius: 100%;
        background: #fff;
        position: absolute;
        left: -21px;
        top: 50%;
        transform: translateY(-50%);
        z-index: 2;
        transition: all 0.1s ease-in-out;
    }
    &:first-of-type {
        margin-top: 0;
    }
    &.active {
        &:before {
            height: 2px;
            width: 2px;
            border: 2px solid #fdd804;
            background: #4f555e;
        }
    }
`;

export const CombosItemEventDescription = styled(boxFlex)`
    width: calc(100% - 40px);
`;

export const CombosItemEventOdds = styled(boxFlex)`
    width: 40px;
    font-size: ${({ isModal }) => (isModal ? '13px' : '10px')};
    line-height: 16px;
    text-align: right;
`;
